/* Reuse the primary form so variant, quantity, selling plans and cart flow stay in sync. */
if (!customElements.get('woodlas-sticky-purchase')) {
  customElements.define('woodlas-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.main = document.querySelector('product-info[id^="MainProduct-"]');
      if (!this.main) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.button = this.querySelector('[data-sticky-add]');
      this.label = this.button.querySelector('span');
      this.spinner = this.button.querySelector('.loading__spinner');
      this.button.addEventListener('click', () => {
        const primary = this.primaryButton();
        if (!primary || primary.disabled || primary.getAttribute('aria-disabled') === 'true') return;
        primary.click();
        this.sync();
      }, { signal });
      this.main.addEventListener('change', () => this.sync(), { signal });
      this.mutations = new MutationObserver(() => this.sync());
      this.mutations.observe(this.main, { subtree:true, childList:true, attributes:true,
        attributeFilter:['disabled','aria-disabled','class','value'] });
      const description = document.querySelector('#MainContent woodlas-description, #MainContent .wl-description') || this.main.querySelector('.product__description');
      this.startSection = description?.closest('.shopify-section') || description || this.main;
      // Content components can have their own <footer>; only the storefront
      // footer group ends the purchase range.
      this.footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer.wl-walnut-footer, footer.clean-footer-wrapper, body > footer');
      // A jump to an anchor may skip an observer threshold. Use the same range
      // check for scrolling, intersection changes and layout/viewport changes.
      const checkPosition = () => {
        if (this.positionFrame) return;
        this.positionFrame = requestAnimationFrame(() => {
          this.positionFrame = 0;
          const pastDescription = this.startSection.getBoundingClientRect().bottom <= 0;
          const beforeFooter = !this.footer || this.footer.getBoundingClientRect().top >= window.innerHeight;
          this.setVisible(!!this.primaryButton() && pastDescription && beforeFooter);
        });
      };
      window.addEventListener('scroll', checkPosition, { signal, passive:true });
      window.addEventListener('resize', checkPosition, { signal, passive:true });
      this.checkPosition = checkPosition;
      this.visibility = new IntersectionObserver(checkPosition);
      this.visibility.observe(this.startSection);
      if (this.footer) this.visibility.observe(this.footer);
      // Tabs, images and reviews can change the range without a scroll event.
      this.rangeSizeObserver = new ResizeObserver(checkPosition);
      this.rangeSizeObserver.observe(this.startSection);
      this.rangeSizeObserver.observe(document.querySelector('#MainContent') || this.main);
      if (this.footer) this.rangeSizeObserver.observe(this.footer);
      this.sizeObserver = new ResizeObserver(() => {
        const clearance = Math.ceil(this.getBoundingClientRect().height) + 18;
        if (clearance > 18) document.body.style.setProperty('--wl-sticky-clearance', `${clearance}px`);
      });
      this.sizeObserver.observe(this);
      this.sync();
      checkPosition();
    }
    primaryButton() {return this.main.querySelector('button[id^="ProductSubmitButton-"]')}
    sync() {
      const primary = this.primaryButton();
      if (!primary) return;
      const loading = primary.getAttribute('aria-disabled') === 'true';
      this.button.disabled = primary.disabled || loading;
      this.button.classList.toggle('loading', loading);
      this.spinner.classList.toggle('hidden', !loading);
      this.label.textContent = primary.querySelector('span')?.textContent.trim() || this.dataset.addLabel;
      const price = this.main.querySelector('[id^="price-"] .price');
      const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      if (amount) this.querySelector('[data-sticky-price]').textContent = amount.textContent.trim();
      const quantity = this.main.querySelector('input[name="quantity"]');
      const variant = this.main.querySelector('variant-selects input:checked + label, variant-selects select option:checked');
      this.querySelector('[data-sticky-selection]').textContent = [variant?.textContent.trim(), `Quantity: ${quantity?.value || 1}`].filter(Boolean).join(' · ');
      this.checkPosition?.();
    }
    setVisible(show) {
      this.hidden = !show;
      this.inert = !show;
      document.body.classList.toggle('wl-sticky-active', show);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.mutations?.disconnect(); this.visibility?.disconnect(); this.sizeObserver?.disconnect(); this.rangeSizeObserver?.disconnect();
      this.controller = null;
      cancelAnimationFrame(this.positionFrame);
      this.positionFrame = 0; this.checkPosition = null;
      document.body.classList.remove('wl-sticky-active');
      document.body.style.removeProperty('--wl-sticky-clearance');
    }
  });
}
